import { useEffect, useRef } from 'react';
import './index.css';

function SubRecordModal({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  isSubmitting = false,
  error = '',
  submitLabel = 'Save',
}) {
  const dialogRef = useRef(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (isOpen) {
      if (!dialog.open) dialog.showModal();
    } else {
      if (dialog.open) dialog.close();
    }
  }, [isOpen]);

  function handleDialogClick(event) {
    // Close on backdrop click (click on the <dialog> element itself, not its content)
    if (event.target === dialogRef.current) {
      onClose();
    }
  }

  function handleCancel(event) {
    // Prevent the browser's default close so we can control state
    event.preventDefault();
    onClose();
  }

  function handleSubmit(event) {
    event.preventDefault();
    onSubmit();
  }

  return (
    <dialog
      className="sub-record-dialog"
      onClick={handleDialogClick}
      onCancel={handleCancel}
      ref={dialogRef}
    >
      <div className="sub-record-dialog-inner">
        <div className="sub-record-dialog-header">
          <h3 className="sub-record-dialog-title">{title}</h3>
          <button
            aria-label="Close"
            className="sub-record-dialog-close icon-button"
            onClick={onClose}
            type="button"
          >
            ✕
          </button>
        </div>

        <form className="sub-record-dialog-body" onSubmit={handleSubmit}>
          {children}

          {error ? <p className="error-text sub-record-dialog-error">{error}</p> : null}

          <div className="sub-record-dialog-footer">
            <button
              className="button-secondary"
              disabled={isSubmitting}
              onClick={onClose}
              type="button"
            >
              Cancel
            </button>
            <button
              className="button-primary"
              disabled={isSubmitting}
              type="submit"
            >
              {isSubmitting ? 'Saving…' : submitLabel}
            </button>
          </div>
        </form>
      </div>
    </dialog>
  );
}

export default SubRecordModal;
